import areasService from '@/services/areas';
import generalCatalogsService from '@/services/generalCatalogs';
import skillsService from '@/services/skills';
import { findOptionByRawValue } from '@/utils/optionValues';
import { normalizeCatalogOptions, normalizeGeoOptions } from '@/utils/catalogOptions';
import { extractCollection, extractPayload } from '@/utils/dataNormalization';
import { SUPPLIERS_TEXT } from '@/texts/catalog/suppliers';

const requestConfig = {};

const extractCreatedItem = (response) => {
  const payload = extractPayload(response);

  if (payload && typeof payload === 'object' && payload.data && typeof payload.data === 'object') {
    return payload.data;
  }

  return payload && typeof payload === 'object' ? payload : null;
};

export const SUPPLIER_MODAL_SECTIONS = [
  {
    key: 'general',
    title: SUPPLIERS_TEXT.modal.sections.general.title,
    description: SUPPLIERS_TEXT.modal.sections.general.description,
    icon: 'fa-id-card-o',
  },
  {
    key: 'contact',
    title: SUPPLIERS_TEXT.modal.sections.contact.title,
    description: SUPPLIERS_TEXT.modal.sections.contact.description,
    icon: 'fa-address-book-o',
  },
  {
    key: 'classification',
    title: SUPPLIERS_TEXT.modal.sections.classification.title,
    description: SUPPLIERS_TEXT.modal.sections.classification.description,
    icon: 'fa-sitemap',
  },
  {
    key: 'address',
    title: SUPPLIERS_TEXT.modal.sections.address.title,
    description: SUPPLIERS_TEXT.modal.sections.address.description,
    icon: 'fa-map-marker',
  },
];

export const loadSupplierModalCatalogs = async () => {
  const [specialtiesResult, areasResult, countriesResult, statesResult] = await Promise.allSettled([
    skillsService.selectors({}, requestConfig),
    areasService.index(requestConfig),
    generalCatalogsService.getCountries(requestConfig),
    generalCatalogsService.getStates(requestConfig),
  ]);

  return {
    specialtyOptions: normalizeCatalogOptions(specialtiesResult.status === 'fulfilled' ? extractCollection(specialtiesResult.value) : [], { useCodeInLabel: false }),
    areaOptions: normalizeCatalogOptions(areasResult.status === 'fulfilled' ? extractCollection(areasResult.value) : [], { useCodeInLabel: false }),
    countryOptions: normalizeGeoOptions(countriesResult.status === 'fulfilled' ? extractCollection(countriesResult.value) : []),
    stateOptions: normalizeGeoOptions(statesResult.status === 'fulfilled' ? extractCollection(statesResult.value) : []),
  };
};

export const resolveSupplierSpecialtiesSelection = (rawSpecialties, specialtyOptions) => {
  const source = Array.isArray(rawSpecialties) ? rawSpecialties : [];
  const matched = source
    .map((specialty) => {
      return findOptionByRawValue(specialtyOptions, specialty, {
        optionKeys: ['id', 'name'],
        metaKeys: ['id', 'name'],
      });
    })
    .filter(Boolean);

  const uniqueByValue = new Map();
  matched.forEach((option) => {
    uniqueByValue.set(String(option?.value || ''), option);
  });

  return Array.from(uniqueByValue.values());
};

export const createSupplierSpecialtyOption = async (name) => {
  const response = await skillsService.store({ name });
  const created = extractCreatedItem(response);
  return normalizeCatalogOptions([created], { useCodeInLabel: false })[0] || null;
};
